import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function Content({
  isContent = true,
  isContainer = false,
  isScrollable = true,
  height = 713,
  className,
  children,
  ...rest
}) {
  return (
    <div
      id="contentId"
      {...rest}
      className={cleanJoin(
        isScrollable ? "scrollbar-no-width overflow-y-scroll" : "",
        isContainer ? "container" : isContent ? "content" : "",
        className
      )}
      style={isScrollable ? { height: height, scrollBehavior: "smooth" } : {}}
    >
      {children}
    </div>
  );
}

export default Content;
